import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';

const TagsManagerWrapper = styled(Dialog.Content)({
  paddingTop: 0,
  h3: {
    marginBottom: 12,
    fontWeight: 500,
    fontSize: '1rem',
  },
});

export default TagsManagerWrapper;
